/* eslint-disable quotes */

const users = {
  tabs: {
    users_list: 'ユーザーリスト',
    default_policy: 'デフォルトポリシー',
    add_update_users: 'ユーザーの追加/更新',
    quarantine_notification: '隔離通知',
    email_continuity: 'Eメールの継続'
  },
  cancel: '[キャンセル]',
  save_changes: '変更を保存',
  users_list: {
    title: 'ユーザーリスト',
    user_role: 'ユーザーロール',
    domains: 'ドメイン',
    all: '[すべて]',
    loading: '読み込み中...',
    no_records_available: '使用可能なレコードはありません',
    add_update_users: 'ユーザーの追加/更新',
    delete_users: 'ユーザーを削除する',
    user_roles: {
      all: '[すべて]',
      domain_admin: 'ドメイン管理者',
      help_desk: 'ヘルプデスク',
      user: 'ユーザ'
    },
    logging_you_as: '「{user}」としてログインしています',
    table: {
      user_id: 'ユーザーアカウント (電子メール)',
      linked_accounts: 'リンクされたアカウント',
      source: '[ソース]',
      role: '役割',
      quarantine: '検疫',
      actions: '[アクション]'
    },
    sources: {
      azure_ad: 'アズール AD',
      ldap: 'LDAP',
      manual: '[マニュアル]',
      auto: 'オート'
    },
    quarantine: {
      enabled: '有効',
      disabled: '無効'
    },
    actions: {
      edit: '[編集]',
      reset_password: 'パスワードをリセット',
      log_in_as: 'このユーザーとしてログイン',
      delete: '[削除]'
    },
    search_placeholder: 'ユーザーアカウント、連結アカウントの検索',
    alerts: {
      success_reset_password: 'ログイン情報が <b>{user}</b> に送信されました',
      failed_reset_password: 'リセットパスワード情報を <b>{user}</b> に送信できません'
    }
  },
  edit_user_dialog: {
    title: 'ユーザーの編集:<b>{user}</b>',
    content_title: '役割と権限',
    user_role: 'ユーザーロール',
    domains: 'ドメイン',
    save: '[保存]',
    cancel: '[キャンセル]',
    user_roles: {
      all: '[例]',
      domain_admin: '｜｜｜｜｜',
      help_desk: 'ヘルプデスク',
      user: 'ユーザ'
    },
    domain: 'ドメイン',
    missed_domain_selection: '選択したユーザーロールのドメインを選択してください',
    user_update_error: 'ユーザーを更新できません'
  },
  delete_user_dialog: {
    title: 'ユーザーを削除する:<b>{user}</b>?',
    titles: '選択した <b>{count}</b> 人のユーザーを削除しますか?',
    content_title: '削除を確認',
    confirm: '[削除]',
    cancel: '[キャンセル]',
    user_delete_error: '選択したユーザーを削除できません'
  },
  default_policy: {
    title: 'デフォルトポリシー',
    information_text: '管理対象ユーザーと管理対象外ユーザーのデフォルトのメールスキャンポリシーを指定します。',
    default_policy_managed_users: '管理対象ユーザー (ユーザーリストのユーザー) のデフォルトポリシー',
    default_policy_unmanaged_users: '管理対象外ユーザー (ユーザーリストにないユーザー) のデフォルトポリシー',
    exempt_senders: '免除差出人',
    exempt_senders_information_text: '注:この値を変更すると、ユーザーの現在のポリシー設定に影響します。',
    allow_users_to_block: 'ユーザーが送信者をブロックすることを許可する',
    allow_users_to_block_information_text: '注:この値を変更すると、ユーザーの現在のポリシー設定に影響します。',
    allow_deliver_blocked_messages: 'エンドユーザーがブロックされたメッセージを表示して配信できるようにする',
    allow_deliver_blocked_messages_information_text:
      '注:これにより、エンドユーザーは潜在的に有害なメッセージを配信したり、危険なリンクをクリックしたりすることができます。',
    allow_deliver_blocked_messages_information_text_2: 'お勧めしません。',
    allow_deliver_quarantined_messages: 'エンドユーザーが隔離されたメッセージを表示および配信できるようにする',
    allow_deliver_quarantined_messages_information_text:
      '注:これにより、エンドユーザーは潜在的に有害なメッセージを配信したり、危険なリンクをクリックしたりすることができます。',
    default_timezone: 'デフォルトタイムゾーン',
    managed_policy_select: {
      allow: '許す',
      scan: 'スキャン',
      block: 'ブロック'
    },
    exempt_senders_select: {
      0: 'ユーザーが送信者を免除することを許可しない',
      1: '送信者の免除をユーザーに許可する',
      2: '送信者を免除することをユーザーに許可するが、管理者禁止リストは上書きしない'
    },
    timezones: {
      'ETC/GMT+12': '国際日付変更線西側',
      'Pacific/Apia': 'ミッドウェー諸島、サモア',
      'Pacific/Honolulu': 'ハワイ',
      'America/Anchorage': 'アラスカ',
      'America/Los_Angeles': '太平洋時間（米国およびカナダ）、ティファナ',
      'America/Phoenix': 'アリゾナ',
      'America/Denver': '山岳部時間（米国およびカナダ）',
      'America/Chihuahua': 'チワワ、ラパス、マサトラン',
      'America/Managua': '中央アメリカ',
      'America/Regina': 'サスカチュワン',
      'America/Mexico_City': 'グアダラハラ、メキシコシティ、モンテレイ',
      'America/Chicago': '中部時間（米国およびカナダ）',
      'America/Indianapolis': 'インディアナ（東部）',
      'America/Bogota': 'ボゴタ、リマ、キト',
      'America/New_York': '東部時間（米国およびカナダ）',
      'America/Caracas': 'カラカス、ラパス',
      'America/Santiago': 'サンティアゴ',
      'America/Halifax': '大西洋時間（カナダ）',
      'America/St_Johns': 'ニューファンドランド',
      'America/Buenos_Aires': 'ブエノスアイレス、ジョージタウン',
      'America/Godthab': 'グリーンランド',
      'America/Sao_Paulo': 'ブラジリア',
      'America/Noronha': '中部大西洋',
      'Atlantic/Cape_Verde': 'カーボベルデ諸島',
      'Atlantic/Azores': 'アゾレス諸島',
      'Africa/Casablanca': 'カサブランカ、モンロビア',
      'Europe/London': 'グリニッジ標準時：ダブリン、エディンバラ、リスボン、ロンドン',
      'Africa/Lagos': '西中央アフリカ',
      'Europe/Berlin': 'アムステルダム、ベルリン、ベルン、ローマ、ストックホルム、ウィーン',
      'Europe/Paris': 'ブリュッセル、コペンハーゲン、マドリード、パリ',
      'Europe/Sarajevo': 'サラエボ、スコピエ、ワルシャワ、ザグレブ',
      'Europe/Belgrade': 'ベオグラード、ブラチスラバ、ブダペスト、リュブリャナ、プラハ',
      'Africa/Johannesburg': 'ハラレ、プレトリア',
      'Asia/Jerusalem': 'エルサレム',
      'Europe/Istanbul': 'アテネ、イスタンブール、ミンスク',
      'Europe/Helsinki': 'ヘルシンキ、キーウ、リガ、ソフィア、タリン、ビリニュス',
      'Africa/Cairo': 'カイロ',
      'Europe/Bucharest': 'ブカレスト',
      'Africa/Nairobi': 'ナイロビ',
      'Asia/Riyadh': 'クウェート、リヤド',
      'Europe/Moscow': 'モスクワ、サンクトペテルブルク、ボルゴグラード',
      'Asia/Baghdad': 'バグダッド',
      'Asia/Tehran': 'テヘラン',
      'Asia/Muscat': 'アブダビ、マスカット',
      'Asia/Tbilisi': 'バクー、トビリシ、エレバン',
      'Asia/Kabul': 'カブール',
      'Asia/Karachi': 'イスラマバード、カラチ、タシケント',
      'Asia/Yekaterinburg': 'エカテリンブルク',
      'Asia/Calcutta': 'チェンナイ、コルカタ、ムンバイ、ニューデリー',
      'Asia/Katmandu': 'カトマンズ',
      'Asia/Colombo': 'スリジャヤワルダナプラコッテ',
      'Asia/Dhaka': 'アスタナ、ダッカ',
      'Asia/Novosibirsk': 'アルマトイ、ノボシビルスク',
      'Asia/Rangoon': 'ヤンゴン',
      'Asia/Bangkok': 'バンコク、ハノイ、ジャカルタ',
      'Asia/Krasnoyarsk': 'クラスノヤルスク',
      'Australia/Perth': 'パース',
      'Asia/Taipei': '台北',
      'Asia/Singapore': 'クアラルンプール、シンガポール',
      'Asia/Hong_Kong': '北京、重慶、香港、ウルムチ',
      'Asia/Irkutsk': 'イルクーツク、ウランバートル',
      'Asia/Tokyo': '大阪、札幌、東京',
      'Asia/Seoul': 'ソウル',
      'Asia/Yakutsk': 'ヤクーツク',
      'Australia/Darwin': 'ダーウィン',
      'Australia/Adelaide': 'アデレード',
      'Pacific/Guam': 'グアム、ポートモレスビー',
      'Australia/Brisbane': 'ブリスベン',
      'Asia/Vladivostok': 'ウラジオストク',
      'Australia/Hobart': 'ホバート',
      'Australia/Sydney': 'キャンベラ、メルボルン、シドニー',
      'Asia/Magadan': 'マガダン、ソロモン諸島、ニューカレドニア',
      'Pacific/Fiji': 'フィジー、カムチャツカ、マーシャル諸島',
      'Pacific/Auckland': 'オークランド、ウェリントン',
      'Pacific/Tongatapu': 'ヌクアロファ'
    }
  },
  add_update_users: {
    title: 'ユーザーの追加/更新',
    user_accounts: 'ユーザーアカウント',
    user_email_error: '有効な E メールアドレスを少なくとも 1 つ入力してください。',
    information_text:
      '以下の設定を使用してユーザーアカウントを手動で作成または更新します。<b>Notify New Users</b> が <i>Yes</i> に設定されている場合、アカウントが作成されるとすぐにユーザーにウェルカムメールが送信されます。ウェルカムメールに記載されたユーザーアカウントログインのリンクは、7 日以内に期限切れになります。',
    enable_user_quarantine: 'ユーザー隔離を有効にする',
    notify_new_users: '新規ユーザーに通知',
    yes: 'はい',
    no: 'いいえ',
    results: {
      base_text: '次のユーザーアカウントアクションが実行されました。',
      quarantine_notification: '隔離通知は {有効、複数、=0 {無効} その他 {有効}} になっています。',
      notified_users: 'ユーザーには電子メールで通知されました。',
      successfully_added: 'ユーザー <b>{user_id} が追加されました</b>。',
      bulk_successfully_added: '<b>{count}</b> 人のユーザーが追加されました。',
      successfully_updated: 'ユーザー <b>{user_id}</b> が更新されました。',
      bulk_successfully_updated: '<b>{count}</b> 人のユーザーが更新されました。',
      failed_to_add_user: 'ユーザー <b>{user_id</b>} を追加できませんでした。',
      failed_to_update_user: 'ユーザー <b>{user_id</b>} を更新できませんでした。',
      invalid_email: '電子メールアドレス <b>{user_id} は有効ではありません</b>。',
      invalid_domain:
        '電子メールドメイン <b>{domain}</b> は許可されていません。認証済みドメインにのみユーザーを追加できます。',
      missed_domain_right: '<b>{domain}</b> のユーザーを管理する権限がありません。',
      already_exists_as_linked_account:
        '<b>{user_id}</b> は連結アカウントとして既に存在しています。別のメールアドレスを選択して追加してください。'
    }
  },
  quarantine_notification: {
    title: '隔離通知',
    quarantine_messages_for_intent_analysis: '意図分析用の隔離メッセージ',
    quarantine_messages_for_intent_analysis_help:
      '「はい」に設定すると、インテント分析によってブロックされるメッセージは代わりに隔離されます。',
    default_interval: 'ユーザー隔離通知のデフォルト間隔',
    scheduled_interval: '通知間隔をスケジュールする',
    scheduled_interval_help:
      '通知は、選択した時間ブロック内の任意の時点で送信されます。クリックしてドラッグして選択します。Ctrl キーを押したままドラッグすると、選択が解除されます。',
    allow_specify_interval: 'ユーザーが間隔を指定できるようにする',
    allow_temp_passcode: 'ユーザーに一時パスコードによるログインを許可',
    allow_temp_passcode_help:
      'ユーザーは、15 分間有効な一時パスコードを受け取ってログインすることができます。これは、ユーザーが共有メールボックスまたは配布リストにサインインする場合に便利です。',
    yes: 'はい',
    no: 'いいえ',
    never: '決して',
    scheduled: 'スケジュール済み'
  },
  email_continuity: {
    title: 'Eメールの継続',
    information_text:
      '指定されたメールサーバーが使用できない場合でも、エンドユーザーが電子メールを送受信できます。E メールコンティニュイティサービスは 96 時間後に自動的に期限切れになります。',
    email_continuity: 'Eメールの継続',
    off: '[オフ]',
    auto_enable: '自動有効化',
    auto_enable_alert:
      'Email Continuityの自動有効化機能を使用すると、このアカウントに関連付けられているすべてのドメインのスプールが有効になります。',
    confirm_dialog: {
      title: 'スプールを有効にする',
      text: 'Email Continuityの自動有効化機能を使用すると、このアカウントに関連付けられているすべてのドメインのスプールが有効になります。',
      confirm: '有効にする',
      cancel: '[キャンセル]'
    }
  }
}

/* eslint-enable quotes */

export default users
